/* eslint-disable */

export const workLoadTimeLine = {
    WORK_LOAD_TIME_LINE_REQUEST: 'WORK_LOAD_TIME_LINE_REQUEST',
    WORK_LOAD_TIME_LINE_SUCCESS: 'WORK_LOAD_TIME_LINE_SUCCESS',
    WORK_LOAD_TIME_LINE_FAILURE: 'WORK_LOAD_TIME_LINE_FAILURE',
};
